export const normalizePhoneInput = (input: string) => {
  let digits = input.replace(/\D/g, "");

  if (digits.startsWith("8")) {
    digits = `7${digits.slice(1)}`;
  } else if (digits.length > 0 && !digits.startsWith("7")) {
    digits = `7${digits}`;
  }

  digits = digits.slice(0, 11);

  if (!digits.length) {
    return "";
  }

  const country = digits[0] || "7";
  const area = digits.slice(1, 4);
  const first = digits.slice(4, 7);
  const second = digits.slice(7, 9);
  const third = digits.slice(9, 11);

  let formatted = `+${country}`;

  if (area) {
    formatted += ` (${area}`;
  }

  if (area.length === 3) {
    formatted += ")";
  }

  if (first) {
    formatted += ` ${first}`;
  }

  if (second) {
    formatted += `-${second}`;
  }

  if (third) {
    formatted += `-${third}`;
  }

  return formatted;
};

export const validatePhone = (value: string) => {
  const digits = value.replace(/\D/g, "");

  if (!digits.length) {
    return "Укажите номер телефона";
  }

  if (digits.length !== 11 || digits[0] !== "7") {
    return "Номер должен быть в формате +7";
  }

  return null;
};

export const validateEmail = (value: string) => {
  const normalized = value.trim();

  if (!normalized) {
    return "Укажите email";
  }

  if (!/^[^\s@]+@[^\s@]+\.[^\s@]{2,}$/i.test(normalized)) {
    return "Некорректный email";
  }

  return null;
};

export const validateFullName = (value: string) => {
  const normalized = value.trim();

  if (!normalized) {
    return "Укажите ФИО";
  }

  return null;
};
